/**
 * Asynchronously loads the component for DealerDashboardPage
 */

import { lazyLoad } from 'utils/loadable';

export const DealerDashboardPage = lazyLoad(
  () => import('./index'),
  module => module.DealerDashboardPage,
);
